import './Home.css';

const Footer = () => {
  return (
    <>
    <footer id="footer">
    <div className="container" data-aos="fade-up">
      <div className="copyright">
        &copy; Copyright <strong><span>Devaprasad</span></strong>
      </div>
      <div class="credits">
       
        {/* Designed by <a href="https://bootstrapmade.com/">BootstrapMade</a> */}
      </div>
    </div>
  </footer>
    </>
  );
}

export default Footer;